import PageStyle from "@/styles/components/play-video-modal/_index.module.scss";
import Button from "@/components/button";
import { CommonAction } from "@/actions/common/common";
import { useState } from "react";
import bcrypt from 'bcryptjs';
import crypto from "crypto";
import { InfoModalStyle } from "@/imports-files/components/common-modal/common-modal";
import Modal from "../common-modal/modal";

export function PlayVideoModal(props)
{
  const apiKey = process.env.NEXT_PUBLIC_MY_INTERVIEW_API_KEY;
  const timestamp =  Math.floor(Date.now() / 1000);
  const secret_key = process.env.NEXT_PUBLIC_MY_INTERVIEW_SECRET_KEY;
  var apiSecret = apiKey + secret_key + timestamp;
  var hash = bcrypt.hashSync(apiSecret, 10);
  return (
    <Modal
      type="info"
      className={`InformationModal mt20`}
      heading=''
      closeModal={() =>
        props.setIntroModal(false)
      }

      innerContent={
        <div className={`${PageStyle.SetupPopup__VideoContainer}`}>
          <iframe
          src={`https://share.myinterview.com/player?apiKey=${apiKey}&hash=${hash}&hashTimestamp=${timestamp}&video=${props.hashKey}&autoplay=0&fs=0`}
          frameborder="0" allowfullscreen webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen></iframe>
       </div>
      }
      />
  )

}
